import { Component } from '@angular/core';

@Component({
  selector: 'app-button',
  standalone: true,
  templateUrl: './button.component.html',
  styleUrls: [],
})
export class ButtonComponent {
  requiredBool: boolean;
}
